import NoCompany from 'app/AppAdmin/NoCompany/NoCompany';
import { Catalog } from 'shared/components/Catalog';

interface IProductProps {
	brand: { id: string };
	setAdminCatalogueSelectedKeys: () => {};
	adminCatalogueSelectedKeys: string[];
}

export const Products = (props: IProductProps) => {
	const { brand, setAdminCatalogueSelectedKeys, adminCatalogueSelectedKeys } = props;
	return (
		<>
			{brand.id ? (
				<Catalog
					location={null}
					isAdminView={true}
					companyId={brand.id}
					setAdminCatalogueSelectedKeys={setAdminCatalogueSelectedKeys}
					adminCatalogueSelectedKeys={adminCatalogueSelectedKeys}
				/>
			) : (
				<NoCompany />
			)}
		</>
	);
};
